import assertNever from 'assert-never';
import { Factory } from 'fishery';
import { DateTime } from 'ts-luxon';

import {
	FirmwareUpdateJobRequest,
	ScheduledJob,
	ScheduledJobRequest,
	ScheduledJobStatus,
	ScheduledJobType
} from '../scheduled-jobs';

export const scheduledJobFactory = Factory.define<ScheduledJob>(({ sequence }) => ({
	id: `scheduled-job-${sequence}`,
	jobId: sequence.toString(),
	name: `Scheduled Job ${sequence}`,
	type: ScheduledJobType.FirmwareUpdate,
	status: ScheduledJobStatus.Pending,
	requestCount: 5,
	executeAt: DateTime.now().plus({ days: 10 }).set({ minute: 0, second: 0, millisecond: 0 }).toJSDate(),
	createdAt: DateTime.now().minus({ days: 10 }).toJSDate(),
	createdBy: `User ${sequence}`,
	updatedAt: DateTime.now().minus({ days: 1 }).toJSDate(),
	updatedBy: `User ${sequence}`
}));

class ScheduledJobRequestFactory extends Factory<ScheduledJobRequest> {
	public firmwareUpdate(params: Partial<FirmwareUpdateJobRequest> = {}): this {
		const defaultParams: Partial<FirmwareUpdateJobRequest> = {
			deviceHardwareId: `device-hardware-${this.sequence()}`,
			hosted: false,
			packageVersion: '1.0.0',
			packageKey: `package-key-${this.sequence()}`
		};

		return this.params({
			type: ScheduledJobType.FirmwareUpdate,
			...defaultParams,
			...params
		});
	}

	public withStatus(status: ScheduledJobStatus): this {
		let executeAt = '';
		switch (status) {
			case ScheduledJobStatus.Cancelled:
			case ScheduledJobStatus.Completed:
			case ScheduledJobStatus.Failed:
			case ScheduledJobStatus.Missed:
				executeAt = DateTime.now().minus({ days: 10 }).toJSDate().toISOString();
				break;
			case ScheduledJobStatus.Executing:
				executeAt = DateTime.now().minus({ minutes: 1 }).toJSDate().toISOString();
				break;
			case ScheduledJobStatus.Pending:
				executeAt = DateTime.now().plus({ days: 10 }).toJSDate().toISOString();
				break;
			default:
				assertNever(status);
		}

		return this.params({
			status,
			executeAt
		});
	}
}

export const scheduledJobRequestFactory = ScheduledJobRequestFactory.define(({ sequence }) => ({
	id: sequence.toString(),
	type: ScheduledJobType.FirmwareUpdate,
	status: ScheduledJobStatus.Pending,
	jobId: `job-${sequence}`,
	executeAt: DateTime.now().plus({ days: 10 }).toJSDate().toISOString() // scheduled for 10 days from now
}));
